import { useFlowContext } from '@/components/flow/hooks/useFlowContext';

import { getCheckoutMode } from '../helpers/getCheckoutMode';

export const useCheckoutMode = () => {
  const { flowType } = useFlowContext();
  return getCheckoutMode(flowType);
};
